<template>
  <div class="auto-registration">
    <OnboardingOverlay />
  </div>
</template>

<script>
import { nextTick } from 'vue'
import OnboardingOverlay from '@/components/OnboardingOverlay/OnboardingOverlay'
import { gtm_login_accountSignUp } from '@/helpers/gtm'

export default {
  name: 'UserRegistration',
  components: {
    OnboardingOverlay,
  },
  mounted() {
    if (!this.is_new) return
    nextTick(() => {
      gtm_login_accountSignUp()
    })
  },
  computed: {
    is_new() {
      const { user_info } = this.$store.getters
      return user_info.is_new
    },
  },
}
</script>
